import { useContext, useEffect, useState } from "react";
import CategorieServices from "../services/categorieServices";
import { AuthContext } from "../contexts/AuthContext";

function useCategorie() {
  const { api } = useContext(AuthContext);
  const service = new CategorieServices(api);

  const getOneCategorie = (id) => {
    return service.getOne(id);
  };

  const createCategorie = (data) => {
    return service.create(data);
  };

  const updateCategorie = (id, data) => {
    return service.update(id, data);
  };

  const deleteCategorie = (id) => {
    return service.delete(id);
  };
  const getAllCategories = () => {
    return service.getAll();
  };

  const getCategoriesGrouped = async () => {
    return service.getAllGrouped();
  };

  const patchManyByGroupe = (idCategorieGroupe, updates) => {
    return service.patchManyByGroupe(idCategorieGroupe, updates);
  };

  return {
    getOneCategorie,
    createCategorie,
    updateCategorie,
    deleteCategorie,
    getAllCategories,
    getCategoriesGrouped,
    patchManyByGroupe
  };
}

export default useCategorie;
